import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=68b13ae0&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style1 from "./Upload.vue?vue&type=style&index=1&id=68b13ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b13ae0",
  null
  
)

export default component.exports